<template>
  <button
    class="rp-cart-button rp-button"
    v-on:click="buyNow"
    v-bind:style="{
      backgroundColor: color.primaryMain,
      color: color.primarySub,
      borderColor: color.primaryMain,
      fontFamily: globalFont
    }">
    <span class="rp-icon">
      <i class="fa fa-lg fa-shopping-cart"></i>
    </span>
    <span>{{ totalProductQuantity }}</span>
  </button>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'ButtonStyle1',
  computed: {
    totalProductQuantity () {
      return Cart.totalProductQuantity
    },
    color () {
      return Cart.getColor()
    },
    globalFont () {
      return Cart.getGlobalFont()
    }
  },
  methods: {
    buyNow () {
      if (this.totalProductQuantity > 0) {
        Cart.$emit('openCart', 'CartView')
      } else {
        let text
        if (Cart.getLocale() == 'en') {
          text = 'Cart Empty!!!'
        } else if (Cart.getLocale() == 'th') {
          text = 'ตะกร้าสินค้าว่าง!!!'
        } else if (Cart.getLocale() == 'vi') {
          text = 'Giỏ hàng trống!!!'
        }
        alert(text)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  span {
    font-family: kanit
  }
  .rp-button {
    min-width: 50px;
  }
  .fa-shopping-cart {
    display: flex;
  }
</style>


// WEBPACK FOOTER //
// src/components/CartButton/ButtonStyle1.vue